import { generateUniqueKey } from '@/utils'

import badge from '@/components/badge'
import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import preloader from '@/components/preloader'

const className = 'sticker'

function renderIcon(h) {
  if (this.icon || this.iconSVG) {
    return h(
      squircle,
      {
        props: {
          color: this.iconColor || this.color,
          icon: this.icon,
          iconSVG: this.iconSVG,
          iconSize: this.iconSize,
          tooltip: this.iconTooltip
        },
        key: generateUniqueKey()
      }
    )
  }

  if (this.$scopedSlots.icon) {
    return this.$scopedSlots.icon()
  }

  return this.$slots.icon
}

function renderTitle(h) {
  return h(
    'div',
    {
      ref: 'title',
      class: `${className}__title`
    },
    [ this.title ]
  )
}
function renderLabel(h) {
  return h(
    'div',
    {
      class: this.$_labelClass
    },
    [ this.label ]
  )
}
function renderContent(h) {
  if (this.hasContent) {
    return h(
      'div',
      {
        class: `${className}__content`,
        directives: this.$_directives
      },
      [
        renderTitle.call(this, h),
        renderLabel.call(this, h)
      ]
    )
  }

  return h('div')
}

function renderButton(h) {
  if (this.hasButton) {
    return h(
      button,
      {
        props: {
          icon: this.$_button.icon,
          iconSVG: this.$_button.iconSVG,
          size: this.$_button.size,
          mode: this.$_button.mode,
          color: this.$_button.color,
          tooltip: this.$_button.tooltip,
          loading: this.$_button.loading,
          disabled: this.$_button.disabled
        },
        on: {
          click: this.buttonClickHandler
        }
      }
    )
  }
}
function renderAfter() {
  if (this.hasAfter) {
    if (this.$scopedSlots.after) {
      return this.$scopedSlots.after()
    }

    return this.$slots.after
  }
}

function renderHolder(h) {
  let tag = 'div'
  if (this.hasTo) {
    tag = 'router-link'
  }

  return h(
    tag,
    {
      class: `${className}__holder`,
      style: { gridTemplateColumns: this.gridTemplateColumns },
      props: { to: this.$_to },
      on: { click: this.clickHandler }
    },
    [
      renderIcon.call(this, h),
      renderContent.call(this, h)
    ]
  )
}

function renderBadge(h, item) {
  return h(
    badge,
    {
      props: item.props,
      key: `badge-${item.position}`
    }
  )
}
function renderBadges(h) {
  return this.$_badges.map(item => {
    return renderBadge.call(this, h, item)
  })
}

function renderLoading(h) {
  if (this.$_loading) {
    return h(
      'div',
      {
        class: `${className}__loading`
      },
      [
        h(
          preloader,
          {
            props: {
              size: 12
            }
          }
        )
      ]
    )
  }
}
function renderProgress(h) {
  if (this.progress !== undefined) {
    return h(
      'div',
      {
        class: `${className}__progress`
      },
      [
        h(
          'div', {
            class: `${className}__progress-bar`,
            style: { transform: `translateX(${-(100 - this.progress)}%)` }
          }
        )
      ]
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      attrs: this.$_attrs,
      class: this.$_class,
      style: this.$_style,
      ref: className
    },
    [
      renderHolder.call(this, h),
      renderButton.call(this, h),
      renderAfter.call(this, h),
      renderBadges.call(this, h),
      renderProgress.call(this, h),
      renderLoading.call(this, h)
    ]
  )
}
